import { Component, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserRole } from 'src/app/_models/userEnum';
import { AuthService } from 'src/app/_services/auth.service';
import { adminLoginResponse } from '../models/entities/admin-login-response';
import { adminLoginRequest } from '../models/requests/admin-login';
import { LoginAdminService } from '../services/login-admin.service';
import { AuthUser } from './AuthUser';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-administrador',
  templateUrl: './administrador.component.html',
  styleUrls: ['./administrador.component.css']
})
export class LoginAdministradorComponent {
  loading = false;
  submitted = false;
  returnUrl: string;
  isPageLoaded = false;
  isProcessing = false;

  loginAdminForm: FormGroup;
  constructor(private fb: FormBuilder,
              private loginService : LoginAdminService,
              private router: Router,
              private authService : AuthService,
              private toastr : ToastrService,
              private renderer : Renderer2,
              private recaptchaV3Service: ReCaptchaV3Service
    ){}

  ngOnInit() {
    // arreglar vista
    this.renderer.removeClass(document.body, 'vertical-overlay-menu');
    this.renderer.removeClass(document.body, 'bg-full-screen-image');
    this.renderer.removeClass(document.body, 'vertical-menu-modern');
    this.renderer.removeClass(document.body, 'fixed-navbar');    
    // arreglar vista
    this.initLoginForm();
    this.isPageLoaded=true;
    const currentUser = this.authService.getUser() as AuthUser;
    if(currentUser) {
      if(currentUser.role===UserRole.Professor)
      {
        this.router.navigate(['docente/historial']);
      }
      if(currentUser.role===UserRole.Company)
      {
        this.router.navigate(['empresa/']);
      }
      if(currentUser.role===UserRole.Graduated)
      {
        this.router.navigate(['egresado/']);
      }
      if(currentUser.role===UserRole.Admin)
      {
        this.router.navigate(['onlyadminaccess/dashboard/']);
      }
    } else {
      this.isPageLoaded = true;
    }
  }
  

  initLoginForm() {
    this.loginAdminForm = this.fb.group({
      usuario: ['', Validators.required],
      password: ['', Validators.required],
      rememberMe: false
    });
  }

  tryLogin()
  {
    this.submitted = true;
    if (!this.loginAdminForm.invalid)
    {
      this.toastr.warning('Verifica los datos.', 'Advertencia', {
        tapToDismiss: false
      });
      return;
    }
    this.isProcessing=true;
    let data : adminLoginRequest = new adminLoginRequest();
    // data.usuario=this.f.usuario.value;
    // data.password=this.f.password.value;
    data.usuario='admin123';
    data.password='admin123';

      this.loginService.loginAdministrator(data).subscribe(response=>
      {
        if(!response.success)
        {
          this.toastr.error('No se encontró un usuario con esas credenciales', 'Error', {
            toastClass: 'ngx-toastr toast-error'
          });
          this.isProcessing=false;
          return;
        }
        this.isProcessing=false;
        this.saveUserStorage(response);
        let returnUrl = '/onlyadminaccess/dashboard';
        if (this.returnUrl) {
           returnUrl = this.returnUrl;
         }
         this.router.navigate([returnUrl]);
      }),
      (error=>{
          this.submitted=false;
          this.isProcessing=false;
        });  

  }


  // convenience getter for easy access to form fields
  get f() {
    return this.loginAdminForm.controls;
  }

  saveUserStorage(res: adminLoginResponse) {
    if (res) {
      const authUser: AuthUser = {
        role:UserRole.Admin,
        token:res.token
      };
      this.authService.saveUser(authUser);
      this.authService.saveAdmin(res);
    } 
  }

}
